// store/index.ts
import { configureStore } from '@reduxjs/toolkit';
import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { rootReducer } from '@/store/rootReducer';
import { createJsonServices } from '@/services/createJsonServices';
import { registerBeforeUnloadHandler } from '@/utils/beforeUnloadCleanup';

const services = createJsonServices();

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      thunk: {
        extraArgument: services
      }

    }),
});

registerBeforeUnloadHandler(() => services);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
